import script from "./pay.vue?vue&type=script&setup=true&lang=js"
export * from "./pay.vue?vue&type=script&setup=true&lang=js"

import "./pay.vue?vue&type=style&index=0&id=69efec5c&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69efec5c"]])

export default __exports__